import { Ref, ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';

import { fetchGetLookupCustomer } from '@/helpers/fetchers';

interface GetCustomerCodesModel {
  loading: Ref<boolean>;
  customerCodes: Ref<string[]>;
  getCustomerCodeList: (value: string) => Promise<void>;
}

export default function useGetLookupCustomerCode(): GetCustomerCodesModel {
  const loading = ref<boolean>(false);
  const customerCodes = ref<string[]>([]);

  function _getCustomerCodeList(value: string): void {
    if (value.length >= 1) {
      loading.value = true;
      void fetchGetLookupCustomer({ customer_code: value })
        .then((ans) => {
          customerCodes.value = ans;
        })
        .finally(() => {
          loading.value = false;
        });
    }
  }

  const getCustomerCodeList = useDebounceFn(_getCustomerCodeList, 600);

  return {
    loading,
    customerCodes,
    getCustomerCodeList,
  };
}
